module.exports = __webpack_public_path__ + "330231673487bd037f54cafc7f410c2e.svg";